import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { List } from '../index';

const useStyles = makeStyles((theme) => ({
  root: {},
  body: {
    width: '100%',
  },
  head: {
    marginTop: '2rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.5rem',
    letterSpacing: 0,
    color: theme.palette.font.main,
    fontWeight: '500',
  },
}));

export default function OnDuty({
  ondutyList,
  setOndutyList,
  staffList,
  publishCtrl,
  head,
  handleEdit,
  setAlertInfo,
  dutyTemplateGroupId,
  dutyCheckList,
  enableSmartComm,
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {head.length > 0 && <div className={classes.head}>{head}</div>}
      <Box display="flex" flexWrap="wrap" className={classes.body}>
        {ondutyList.map((item, index) => (
          <Box mr="1.25rem" mt="1.625rem" key={item.id}>
            <List
              head={item.title}
              height={item.height}
              headcolor="0"
              cardList={item.dutyStaffs}
              listIndex={index}
              listID={item.id ?? index}
              ondutyList={ondutyList}
              setOndutyList={setOndutyList}
              srsMapping={item.srsMapping ?? []}
              staffList={staffList}
              publishCtrl={publishCtrl}
              handleEdit={handleEdit}
              setAlertInfo={setAlertInfo}
              dutyTemplateGroupId={dutyTemplateGroupId}
              dutyCheckList={dutyCheckList}
              enableSmartComm={enableSmartComm}
            />
          </Box>
        ))}
      </Box>
    </div>
  );
}
